import graphql from "babel-plugin-relay/macro";
import { useFragment } from "react-relay";

import { usePackageMonthlyPrice_memberPackage$key } from "./__generated__/usePackageMonthlyPrice_memberPackage.graphql";

export const usePackageMonthlyPrice = (
  memberPackageRef: usePackageMonthlyPrice_memberPackage$key | null | undefined
) => {
  const memberPackage = useFragment(
    usePackageMonthlyPriceFragmentString,
    memberPackageRef
  );

  const billingType = memberPackage?.package?.billingType;
  const billingCharges =
    memberPackage?.package?.billingOptions
      ?.flatMap((bo) => (bo?.billingCharges ? bo.billingCharges : []))
      .flatMap((c) => (c?.squareVariation ? [c] : [])) || [];

  return billingType === "SUBSCRIPTION"
    ? billingCharges
        .filter((charge) => charge?.frequency === "MONTHLY")
        .reduce((acc, charge) => {
          return acc + (charge?.squareVariation?.amount || 0);
        }, 0)
    : undefined;
};

const usePackageMonthlyPriceFragmentString = graphql`
  fragment usePackageMonthlyPrice_memberPackage on MemberPackage {
    package {
      billingType
      billingOptions {
        billingCharges {
          frequency
          squareVariation {
            amount
          }
        }
      }
    }
  }
`;
